const TOKEN_STORAGE_KEY = "blackadder:admin_token";
const COOKIE_NAME = "admin_api_token";
const AUTH_TOKEN_QUERY_KEY = "adminAuthToken";

const getStorage = (): Storage | null => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

const readTokenFromCookie = (): string | null => {
  if (typeof document === "undefined") return null;

  const cookies = document.cookie.split(";");
  const tokenCookie = cookies.find((cookie) =>
    cookie.trim().startsWith(`${COOKIE_NAME}=`)
  );

  if (!tokenCookie) return null;
  const [, value] = tokenCookie.split("=");
  return value ? decodeURIComponent(value) : null;
};

const clearCookieToken = () => {
  if (typeof document === "undefined") return;

  const host = typeof window !== "undefined" ? window.location.hostname : undefined;
  const domains = new Set<string>([""]);

  if (host) {
    domains.add(host);
    if (host.endsWith(".blackadder.local") || host === "blackadder.local") {
      domains.add(".blackadder.local");
    }
    if (host.endsWith(".blackadder.co.jp") || host === "blackadder.co.jp") {
      domains.add(".blackadder.co.jp");
    }
  }

  domains.forEach((domain) => {
    const domainPart = domain ? `; domain=${domain}` : "";
    document.cookie = `${COOKIE_NAME}=; Max-Age=0; Path=/${domainPart}; Secure; SameSite=None`;
  });
};

export const getStoredToken = (): string | null => {
  const storage = getStorage();
  if (storage) {
    const stored = storage.getItem(TOKEN_STORAGE_KEY);
    if (stored) return stored;
  }

  const cookieToken = readTokenFromCookie();
  if (cookieToken && storage) {
    storage.setItem(TOKEN_STORAGE_KEY, cookieToken);
  }
  return cookieToken;
};

export const storeToken = (token: string) => {
  const storage = getStorage();
  if (storage) {
    storage.setItem(TOKEN_STORAGE_KEY, token);
  }
};

export const clearStoredToken = () => {
  const storage = getStorage();
  if (storage) {
    storage.removeItem(TOKEN_STORAGE_KEY);
  }
  clearCookieToken();
};

export const appendTokenToUrl = (targetUrl: string, token: string): string => {
  if (!token) return targetUrl;
  try {
    const base = typeof window !== "undefined" ? window.location.origin : undefined;
    const url = new URL(targetUrl, base);
    url.searchParams.set(AUTH_TOKEN_QUERY_KEY, token);
    return url.toString();
  } catch {
    return targetUrl;
  }
};

export const bootstrapTokenFromUrl = (): string | null => {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    const token = url.searchParams.get(AUTH_TOKEN_QUERY_KEY);
    if (!token) return null;

    storeToken(token);
    url.searchParams.delete(AUTH_TOKEN_QUERY_KEY);
    const cleanUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState({}, document.title, cleanUrl);
    return token;
  } catch {
    return null;
  }
};
